export default {
  title: 'Toegangsbeheer: {{role}}',
  form: {
    companies: {
      label: 'Zichtbaar voor alle leden met de rol {{role}}',
      tooltip: 'Dit wordt toegevoegd aan de locaties waar het teamlid zich heeft aangemeld',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt, vernieuw de pagina',
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
  },
};
